import { useSelector } from "react-redux";
import { getDistanceKm, formatDistance } from "../utils/distance";

const useDistanceLabel = (targetLat, targetLng) => {
  const coordinate = useSelector((state) => state.location.coordinate);

  const lat1 = Number(coordinate?.lat);
  const lon1 = Number(coordinate?.lon);
  const lat2 = Number(targetLat);
  const lon2 = Number(targetLng);

  if ([lat1, lon1, lat2, lon2].some((n) => Number.isNaN(n))) return null;

  return formatDistance(getDistanceKm(lat1, lon1, lat2, lon2));
};

export default useDistanceLabel;
